export default __webpack_public_path__ + "static/media/angular.1fd4bbed.svg";